// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniCartStyles } from "@ces/App/Components/MiniCart/MiniCart";
import { constants } from "@ces/XDL/constants";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, styledScrollbar, xScreen } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

miniCartStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 462px;
        gap: 20px;
        max-height: calc(100vh - ${constants.header.size.height}px);
        ${xScreen("lte", "md")} {
            max-height: calc(100vh - ${constants.header.tablet.size.height}px);
            ${IconWrapper} {
                width: 23px;
            }
        }
    `,
};

miniCartStyles.centerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 16px;
        width: 462px;
    `,
};

miniCartStyles.notifyWrapper = {
    css: css`
        padding: 16px;
    `,
};

miniCartStyles.noCartLinesNotify = {
    css: css`
        font-size: 12px;
        line-height: 13px;
        margin: 0;
    `,
};

miniCartStyles.notify = {
    css: css`
        font-size: 12px;
        line-height: 14px;
        margin: 0;
        padding: 12px;
        align-items: flex-start;
    `,
};

miniCartStyles.viewCartLink = {
    color: "secondary",
    typographyProps: {
        size: 12,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 18px;
        `,
    },
};

miniCartStyles.cartLinesWrapper = {
    css: css`
        position: relative;
        max-height: calc(80vh - ${constants.header.size.height}px);
        padding: 16px 8px 0 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        ${styledScrollbar()}
    `,
};

miniCartStyles.cartLinesContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 20px;
    `,
};

miniCartStyles.productAvailabilityStyles = {
    container: {
        gap: 0,
        css: css`
            width: auto;
            flex: 1 0 auto;
        `,
    },
};

miniCartStyles.bottomWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        border-top: 1px solid ${color("common.border")};
        padding: 16px;
        row-gap: 12px;
    `,
};

miniCartStyles.bottomSectionWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        column-gap: 12px;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

miniCartStyles.totalItem = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 4px;
    `,
};

miniCartStyles.totalLabel = {
    size: 14,
    weight: fontConfig.weight.regular,
    lineHeight: "22px",
};

miniCartStyles.totalValue = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

miniCartStyles.checkoutButton = {
    css: css`
        flex: 1;
        max-width: 50%;
    `,
};

miniCartStyles.viewCartButton = {
    variant: "tertiary",
    css: css`
        flex: 1;
        max-width: 50%;
    `,
};
